<div class="sub-heading-m">{{ 'ALERTING.ISSUE_DETAILS' | translate }}</div>

<div class="alert-detail-content">
  <div class="body-s alert-detail-title">
    {{ 'ALERTING.ALERT_STATUS_' + alert.alertSubType | translate }}
  </div>
  <div class="session-alert-lines">
    @for (line of issueDetailLines; track line.id) {
      <div class="body-m session-alert-text">
        @if (line.text) {
          {{ line.text }}
        } @else {
          {{
            line.translationKey || 'ALERTING.ISSUE_DETAILS_TEXT_UNKNOWN' | translate: line.params
          }}
        }
      </div>
    }
  </div>
</div>

@if (reasonTitleKey && sessionAlertDetails?.revenueDetail?.errors?.length) {
  <div class="alert-detail-content">
    <div class="body-s alert-detail-title">{{ reasonTitleKey | translate }}</div>
    <div class="session-alert-reasons">
      @for (reason of sessionAlertDetails?.revenueDetail?.errors; track reason.errorCode) {
        <div class="session-alert-reason body-m">
          <span class="session-alert-reason-code">
            {{ reason.errorCode | alertErrorCodeTranslationKey | translate }}
          </span>
          <span class="session-alert-reason-count">
            <eop-chip
              [chipColor]="ChipColor.DEFAULT"
              [chipSize]="ChipSize.SMALL"
              [text]="`${reason.count}x`"></eop-chip
          ></span>
          <span class="session-alert-reason-description">
            {{ `ALERTING.ERROR_CODE_DESCRIPTION_${reason.errorCode}` | translate }}
          </span>
        </div>
      }
    </div>
  </div>
}

<div class="alert-detail-content">
  <div class="body-s alert-detail-title">{{ 'GLOBAL.LEARN_MORE' | translate }}</div>
  <div class="session-alert-actions">
    @for (action of learnMoreActions; track action.dataTestId) {
      @switch (action.type) {
        @case ('route') {
          <button
            eopButton
            [size]="ButtonSize.SMALL"
            [color]="ButtonColor.SECONDARY"
            [leftIcon]="action.leftIcon"
            [rightIcon]="action.rightIcon"
            [dataTestId]="action.dataTestId"
            [routerLink]="action.route"
            [queryParams]="action.queryParams">
            {{ action.labelKey | translate }}
          </button>
        }
        @case ('external') {
          <button
            eopButton
            [size]="ButtonSize.SMALL"
            [color]="ButtonColor.OUTLINE_TRANSPARENT"
            [leftIcon]="action.leftIcon"
            [rightIcon]="action.rightIcon"
            [dataTestId]="action.dataTestId"
            (click)="openKnowledgeBase(action.url)">
            {{ action.labelKey | translate }}
          </button>
        }
        @case ('vayla') {
          <button
            eopButton
            [size]="ButtonSize.SMALL"
            [color]="ButtonColor.OUTLINE_TRANSPARENT"
            [leftIcon]="action.leftIcon"
            [rightIcon]="action.rightIcon"
            [dataTestId]="action.dataTestId"
            [disabled]="askVaylaDisabled()"
            (click)="onAskVayla(action.promptKey)">
            {{ action.labelKey | translate }}
          </button>
        }
      }
    }
  </div>
</div>
